import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, REGULAR_PRICE, TODAY_PRICE } from '../data/product';
const recap = ['250+ Exercises', '100 Ready-to-Use Sessions', '12-Month Programming', '6 Professional Modules', '5 Premium Bonuses'];
export function FinalCTA() {
  return <section className="bg-ink text-white px-4 sm:px-6 py-9 sm:py-12" data-id="element-44" data-mp="84xk2ewmfz04">
      <div className="max-w-2xl mx-auto text-center" data-id="element-45" data-mp="m4ykxucvz6fl">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-2.5" data-id="element-46" data-mp="m3dq03mntlh7">
          Next week is coming either way.
        </h2>

        <p className="font-heading font-semibold uppercase text-[11px] sm:text-sm tracking-wide text-lime leading-snug max-w-xl mx-auto mb-5" data-id="element-47" data-mp="vv1f3xvquqfi">
          The question is whether you want to build everything again.
        </p>

        <p className="text-[13px] sm:text-base text-white/70 leading-relaxed max-w-lg mx-auto mb-5" data-id="element-48" data-mp="14vzge8essjue">
          You already have the coaching experience. Fitness Senior Ready™ gives
          you the organized system behind it.
        </p>

        <ul className="flex flex-wrap justify-center gap-1.5 mb-6" data-id="element-49" data-mp="2h3ri8mmvdngt">
          {recap.map(item => <li key={item} className="rounded bg-white/[0.06] border border-white/10 px-2 py-1 text-[10px] sm:text-xs font-semibold text-white/85" data-id="element-50" data-mp="2m3416wameae4">
              {item}
            </li>)}
        </ul>

        <div className="bg-white/[0.05] border border-lime/30 rounded-xl p-4 max-w-xs sm:max-w-sm mx-auto mb-4" data-id="element-51" data-mp="2v2zgndb7krjy">
          <h3 className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight mb-2" data-id="element-52" data-mp="300sk3yl4n7gj">
            Fitness Senior Ready™
          </h3>
          <p className="text-[12px] line-through text-white/40 mb-0.5" data-id="element-53" data-mp="39solbiiifdoz">
            {REGULAR_PRICE}
          </p>
          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.16em] text-lime" data-id="element-54" data-mp="3esjfpw1hules">
            Today:
          </p>
          <p className="font-heading font-black text-2xl sm:text-4xl leading-none mb-2" data-id="element-55" data-mp="3iqqskfsu72kp">
            {TODAY_PRICE}
          </p>
          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.12em] text-gold" data-id="element-56" data-mp="1eps7x7c8zwlt">
            One payment. Lifetime access.
          </p>
        </div>

        <div className="max-w-xs sm:max-w-sm mx-auto mb-2.5" data-id="element-57" data-mp="1npyfydp6g4dl">
          <CTAButton href={CHECKOUT_URL} data-id="element-58" data-mp="1none4jfal6p4">
            Yes — I want my senior fitness system
          </CTAButton>
        </div>

        <p className="text-[10px] sm:text-xs font-semibold text-white/50 tracking-wide" data-id="element-59" data-mp="1xfqgrpnvdtqi">
          Instant Access · Secure Payment · 7-Day Guarantee
        </p>
      </div>
    </section>;
}